import { io } from "socket.io-client";

const socket = io("https://api.inwallz.in");

export default socket;
